<template>
	<v-dialog 
		v-model="show" 
		@click:outside="closeDialog()" 
		style="max-height: 100vh"
		max-width="1400"
		content-class="my-auto vh-80"
		@keyup.esc="closeDialog()"
		scrollable
	>
			<v-form ref="form" @submit.prevent="save">
				<v-card class="wall-card">
					<v-card-text class="pa-0">
						<v-row class="ma-0">
							<v-col cols="12" xl="8" lg="8" md="12" class="pa-0">
								<div v-if="type == 'image'" class="bg-black sticky-top relative" style="overflow:hidden" :class="{'img-fullscreen': fullscreen}">
									<div class="image-actions ">
										<v-btn @click="pan = !pan" icon class="ml-auto"  ><v-icon :color="(pan ? 'accent' : 'white')">mdi-magnify</v-icon></v-btn>
										<v-btn :href="post.image.url_download" light icon color="white"><v-icon>$download</v-icon></v-btn>
										<v-btn @click="fullscreen = !fullscreen" light icon color="white">
											<v-icon v-if="fullscreen">mdi-fullscreen-exit</v-icon>
											<v-icon v-else>mdi-fullscreen</v-icon>
										</v-btn>
									</div>
									<panZoom v-if="pan" :options="{minZoom: 0.5, maxZoom: 5}">
										<img :src="post.image.url" lazy-src="@/assets/images/image-placeholder.jpg" class="bg-black rounded image-preview">
									</panZoom>

									<v-img
										@click="pan = !pan"
										@scroll.native="pan = true" 
										v-else
										contain
										:src="post.image.url"
										lazy-src="@/assets/images/image-placeholder.jpg"
										class="image-preview bg-black rounded zoom-in"
									/>

								</div>
							</v-col>
							<v-col cols="12" xl="4" lg="4" class="pa-0">
								<div class="bold font-14 text-black d-flex align-items-center w-100 px-6 mt-3">Podgląd wpisu
									<v-btn icon @click="closeDialog()" class="ml-auto">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</div>
								<post :post="post" :simple="simple" no-card hide-image />
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-form>
	</v-dialog>						
</template>

<script>

import Post from '@/components/wall/post/Post';
export default {
	components: {
		Post
	},
	props: {
		post: {
			type: Object,
			required: true
		},
		type: {
			type: String,
			required: true
		},
		simple: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			show: true,
			dialogVisible: false,
			showCommentAdd: false,
			showComments: true,
			pan: false,
			fullscreen: false
		}
	},
	watch: {
		show(newVal) {
			console.log("NEW VAL TO CLOSE", newVal)
			if(newVal == false) {
				this.closeDialog();
			}
		}
	},
	computed: {
		edited() {
			return this.post.created_at !== this.post.updated_at;
		},
		comments: function () {
			return !this.post.is_comments_disabled
		},
	},
	methods: {
		closeDialog() {
			this.$emit('closed');
		}
	},
	created() {
		console.log("PREVIEW CREATED")
	}

}
</script>

<style lang="scss">
	.sticky-top {
		position: sticky;
		position: -webkit-sticky;
		top: 0;
	}
	.image-preview {
		max-height: calc(95vh);
		min-height: calc(95vh);
	}
	.image-actions {
		position: absolute;
		top: 0;
		right: 0;
		padding: 12px;
		display: flex;
		align-items: center;
		flex-direction: row;
		z-index: 1;
		width: 100%;
		background: linear-gradient(
			0deg,
			rgba(255, 255, 255, 0) 10%,
			rgba(0, 0, 0, 1) 100%
		);
	}
	.zoom-in {
		cursor: zoom-in;
	}
	.img-fullscreen {
		overflow: hidden;
		position: fixed;
		z-index: 999;
		left: 0;
		top: 0;
		height: 100vh;
		width: 100%;
	}
</style>